<template>
  <div class="mx-auto px-4 sm:px-6 lg:px-8">
    <h1 class="text-2xl font-semibold text-gray-900 mb-4">
      <slot />
    </h1>
  </div>
</template>
